// Generated by CoffeeScript 1.10.0
(function() {
  var BBCodeElement, BBDocument, BBElement, BBImgElement, BBListElement, BBListItemElement, BBNode, BBPreElement, BBQuoteElement, BBText, BBURLElement, BlockList, escapeHTML, escapeHTMLAttr, isValidURL, ref,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BlockList = require('./blocks');

  ref = require("./htmlutil"), escapeHTML = ref.escapeHTML, escapeHTMLAttr = ref.escapeHTMLAttr, isValidURL = ref.isValidURL;

  BBNode = (function() {
    function BBNode() {
      this.parent = null;
      this.children = [];
    }

    BBNode.prototype.onChildTag = function(event) {
      return false;
    };

    BBNode.prototype.onEndTag = function(event) {
      return false;
    };

    BBNode.prototype.onText = function(event) {
      return this.appendText(event.text);
    };

    BBNode.prototype.appendChild = function(child) {
      if (child.parent !== null) {
        throw new Error("Attempting to add child that already has a parent");
      }
      child.parent = this;
      this.children.push(child);
      return child;
    };

    BBNode.prototype.appendText = function(text) {
      return this.appendChild(new BBText(text));
    };

    BBNode.prototype.makeBlocks = function(list) {
      var child, i, len, ref1, results;
      ref1 = this.children;
      results = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        child = ref1[i];
        results.push(child.makeBlocks(list));
      }
      return results;
    };

    return BBNode;

  })();

  BBElement = (function(superClass) {
    extend(BBElement, superClass);

    function BBElement(htmlStart, htmlEnd, nests) {
      this.htmlStart = htmlStart;
      this.htmlEnd = htmlEnd;
      this.nests = nests != null ? nests : true;
      BBElement.__super__.constructor.call(this);
    }

    BBElement.prototype.onChildTag = function(event) {
      return this.nests;
    };

    BBElement.prototype.makeBlocks = function(list) {
      list.append(this.htmlStart);
      BBElement.__super__.makeBlocks.call(this, list);
      return list.append(this.htmlEnd);
    };

    return BBElement;

  })(BBNode);

  BBURLElement = (function(superClass) {
    extend(BBURLElement, superClass);

    function BBURLElement(rawStart, url1) {
      this.rawStart = rawStart;
      this.url = url1;
      BBURLElement.__super__.constructor.call(this, "<a>", "</a>");
    }

    BBURLElement.prototype.onChildTag = function(event) {
      return true;
    };

    BBURLElement.prototype._makeLink = function(url) {
      return "<a href=\"" + (escapeHTMLAttr(url)) + "\" rel=\"nofollow\">";
    };

    BBURLElement.prototype.makeBlocks = function(list) {
      var child, url;
      if (this.url != null) {
        this.htmlStart = this._makeLink(this.url);
      } else {
        if (this.children.length === 1) {
          child = this.children[0];
          if (child instanceof BBText) {
            url = child.data;
            if (isValidURL(url)) {
              this.htmlStart = this._makeLink(url);
              return BBURLElement.__super__.makeBlocks.call(this, list);
            }
          }
        }
        this.htmlStart = escapeHTML(this.rawStart);
        this.htmlEnd = "[/url]";
      }
      return BBURLElement.__super__.makeBlocks.call(this, list);
    };

    return BBURLElement;

  })(BBElement);

  BBQuoteElement = (function(superClass) {
    extend(BBQuoteElement, superClass);

    function BBQuoteElement(quoted) {
      BBQuoteElement.__super__.constructor.call(this, "<blockquote>", "</blockquote>");
      if (quoted != null) {
        this.htmlStart = ("<div class=\"quoted-name\">" + (escapeHTML(quoted)) + "</div>") + this.htmlStart;
      }
    }

    return BBQuoteElement;

  })(BBElement);

  BBImgElement = (function(superClass) {
    extend(BBImgElement, superClass);

    function BBImgElement(rawStart) {
      this.rawStart = rawStart;
      BBImgElement.__super__.constructor.apply(this, arguments);
      this.url = [];
    }

    BBImgElement.prototype.onChildTag = function(event) {
      return false;
    };

    BBImgElement.prototype.onText = function(event) {
      return this.url.push(event.text);
    };

    BBImgElement.prototype.onEndTag = function(event) {
      if (event.tag === 'img') {
        return this.rawEnd = event.raw;
      } else {
        return this.rawEnd = "";
      }
    };

    BBImgElement.prototype.makeBlocks = function(list) {
      var url;
      url = this.url.join('');
      if (isValidURL(url)) {
        return list.appendHTML("<img src=\"" + (escapeHTMLAttr(url)) + "\">");
      } else {
        return list.appendHTML(escapeHTML(this.rawStart + url + this.rawEnd));
      }
    };

    return BBImgElement;

  })(BBNode);

  BBListElement = (function(superClass) {
    extend(BBListElement, superClass);

    function BBListElement(type) {
      var end, listStyle, start;
      this.type = type;
      if (this.type in BBListElement.ALLOWED_TYPES) {
        listStyle = BBListElement.ALLOWED_TYPES[this.type];
        start = "<ol class=\"bbcode-list-" + listStyle + "\" style=\"list-style-type: " + listStyle + "\">";
        end = "</ol>";
      } else {
        start = "<ul>";
        end = "</ul>";
      }
      BBListElement.__super__.constructor.call(this, start, end, true);
    }

    BBListElement.ALLOWED_TYPES = {
      '1': 'decimal',
      'a': 'lower-alpha',
      'A': 'upper-alpha'
    };

    return BBListElement;

  })(BBElement);

  BBListItemElement = (function(superClass) {
    extend(BBListItemElement, superClass);

    function BBListItemElement() {
      BBListItemElement.__super__.constructor.call(this, "<li>", "</li>", true);
    }

    BBListItemElement.prototype.onChildTag = function(event) {
      if (event.tag === '*') {
        event.closeTag();
      }
      return true;
    };

    return BBListItemElement;

  })(BBElement);

  BBPreElement = (function(superClass) {
    extend(BBPreElement, superClass);

    function BBPreElement(element) {
      this.element = element != null ? element : "pre";
      BBPreElement.__super__.constructor.apply(this, arguments);
      this.content = [];
    }

    BBPreElement.prototype.onChildTag = function(event) {
      return false;
    };

    BBPreElement.prototype.onText = function(event) {
      return this.content.push(event.text);
    };

    BBPreElement.prototype.makeBlocks = function(list) {
      return list.appendRawHTML("<" + this.element + ">" + (escapeHTML(this.content.join(''))) + "</" + this.element + ">");
    };

    return BBPreElement;

  })(BBNode);

  BBCodeElement = (function(superClass) {
    extend(BBCodeElement, superClass);

    function BBCodeElement(codeType) {
      this.codeType = codeType;
      BBCodeElement.__super__.constructor.apply(this, arguments);
    }

    BBCodeElement.prototype.makeBlocks = function(list) {
      return list.appendRawHTML("<pre><code>" + (escapeHTML(this.content.join(''))) + "</code></pre>");
    };

    return BBCodeElement;

  })(BBPreElement);

  BBText = (function(superClass) {
    extend(BBText, superClass);

    BBText.prototype.data = "";

    function BBText(data) {
      BBText.__super__.constructor.call(this);
      this.data = data;
    }

    BBText.prototype.makeBlocks = function(list) {
      return list.append(escapeHTML(this.data));
    };

    return BBText;

  })(BBNode);

  BBDocument = (function(superClass) {
    extend(BBDocument, superClass);

    function BBDocument() {
      BBDocument.__super__.constructor.apply(this, arguments);
    }

    BBDocument.prototype.onChildTag = function(event) {
      return true;
    };

    BBDocument.prototype.toBlocks = function() {
      var list;
      list = new BlockList();
      this.makeBlocks(list);
      return list;
    };

    return BBDocument;

  })(BBNode);

  exports.BBNode = BBNode;

  exports.BBElement = BBElement;

  exports.BBURLElement = BBURLElement;

  exports.BBQuoteElement = BBQuoteElement;

  exports.BBImgElement = BBImgElement;

  exports.BBPreElement = BBPreElement;

  exports.BBCodeElement = BBCodeElement;

  exports.BBListElement = BBListElement;

  exports.BBListItemElement = BBListItemElement;

  exports.BBText = BBText;

  exports.BBDocument = BBDocument;

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/bitter-bbcode/lib/bbdom.js
 ** module id = ./node_modules/bitter-bbcode/lib/bbdom.js
 ** module chunks = 1
 **/